import React, { ReactNode } from 'react';
import { Row, Col } from 'antd';
import CourseCard, { CourseType } from '../CourseCard/CourseCard';
import './CourseCardList.less';
import withSkeleton from '../../hoc/withSkeleton';
import CourseCardListSkeleton from './CourseCardListSkeleton';
import { GridType } from '../../types';

export type CourseListProps = {
  courseList: CourseType[];
  renderItem?: (item: CourseType, index: number) => ReactNode;
  renderActions?: (item: CourseType) => ReactNode;
  grid: GridType;
  contentHeight?: string;
};

const TCourseCardList: React.FC<CourseListProps> = ({
  courseList,
  renderItem,
  renderActions = () => null,
  grid,
  contentHeight,
}) => {
  return (
    <Row {...grid?.row}>
      {courseList.map((item, index) => {
        if (renderItem) {
          if (grid?.col) {
            return (
              <Col key={index} {...grid.col}>
                {renderItem(item, index)}
              </Col>
            );
          }
          return renderItem(item, index);
        }

        return (
          <Col key={index} {...grid?.col}>
            <CourseCard
              course={item}
              actions={renderActions(item)}
              contentHeight={contentHeight}
            />
          </Col>
        );
      })}
    </Row>
  );
};

export default withSkeleton(TCourseCardList, CourseCardListSkeleton);
